module.exports = __webpack_public_path__ + "media/images/promo/championship/01_n-00343516ec1c5fea7373fb8ba34d91bc.png";